const e = {
  value: [],
  disableBackspaceChipRemove: !1,
  separatorCode: "Space"
};
export { e as InputChipsDefaultProps };